import axios from "axios";

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("afterflow_session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const api = client;

export function storeSession(session) {
  localStorage.setItem("afterflow_session_token", session.token);
}

export function clearSession() {
  localStorage.removeItem("afterflow_session_token");
}